import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BirthdayIcon from "../../../images/BirthdayIcon.png";
import MarritialStatusIcon from "../../../images/MarritialStatusIcon.png";
import ProfileEditIcon from "../../../images/ProfileEditIcon.png";
import Profileicon from "../../../images/Profileicon.png";
import heightIcon from "../../../images/heightIcon.png";
import hinduIcon from "../../../images/hinduIcon.png";
import chatIcons from "../../../images/chatIcons.png";
import locationIcon from "../../../images/locationIcon.png";
import salaryIcon from "../../../images/salaryIcon.png";
import BloodGroupIcon from "../../../images/BloodGroupIcon.png";
import dateIcon from "../../../images/dateIcon.png";
import neverIcon from "../../../images/neverIcon.png";
import selfIcon from "../../../images/selfIcon.png";
import educIcon from "../../../images/educIcon.png";
import jobIcon from "../../../images/jobIcon.png";
import FatherNameIcon from "../../../images/FatherNameIcon.png";
import FatherOccupationIcon from "../../../images/FatherOccupationIcon.png";
import MotherNameIcon from "../../../images/MotherNameIcon.png";
import MotherOccupationIcon from "../../../images/MotherOccupationIcon.png";
import homeIcon from "../../../images/homeIcon.png";
import homefIcon from "../../../images/homefIcon.png";
import greenOnline from "../../../images/greenOnline.png";
import photoImg from "../../../images/photoImg.png";
import greenCheckIcon from "../../../images/greenCheckIcon.png";
import grayCheckIcon from "../../../images/grayCheckIcon.png";
import domainIcon from "../../../images/Domain.png";
import gothraIcon from "../../../images/GothramIcon.png";
import padma from "../../../images/padma.png";
import weightIcon from "../../../images/Weight.png";
import normalIcon from "../../../images/PhysicalStatusIcon.png";
import bodyIcon from "../../../images/BodyTypeIcon.png";
import fairIcon from "../../../images/complexcion.png";
import drinkIcon from "../../../images/drinkIcon.png";
import dietIcon from "../../../images/dietIcon.png";
import smokingIcon from "../../../images/smokingIcon.png";
import Religion from "../../../images/Religion.jpg";
import Community from "../../../images/Community.png";
import sevvaiDosham from "../../../images/SevvaiDoshamIcon.png";
import starIcon from "../../../images/StartIcon.png";
import subCaste from "../../../images/SubCasteIcon.png";
import walletIcon from "../../../images/walletIcon.png";
import countryIcon from "../../../images/locationIcon.png";
import stateIcon from "../../../images/locationIcon.png";
import cityIcon from "../../../images/locationIcon.png";
import familyValueIcon from "../../../images/familyValueIcon.png";
import jointFamilyIcon from "../../../images/familyTypeIcon.png";
import familyStatusIcon from "../../../images/familyStatusIcon.png";
import familyOriginIcon from "../../../images/familyOriginIcon.png";
import Siblingsicon from "../../../images/Siblingsicon.png";
import { Avatar, Box, CardHeader, CircularProgress, Grid, Skeleton, Typography } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import greyOnline from "../../../images/grayCheckIcon.png";
import { ActionButton } from './ActionButton';
import { toast, ToastContainer } from 'react-toastify';
import { getProfileById } from '../../../asiosConfig';
import boyBanner from "../../../images/blankPicBoy1.png";
import girlBanner from "../../../images/blankPic1.png";
import MotherTongue from "../../../images/MotherTongue.png";
import boyImg from "../../../images/blankPicBoy2.png";
import gitlImg from "../../../images/blankPic3.png";
import ShareIcon from '@mui/icons-material/Share'; // Import Share icon
import IconButton from '@mui/material/IconButton'; // Import IconButton

export const ProfileView = () => {
    const location = useLocation();
    const { id } = useParams();
    const navigate = useNavigate();
    const { user_id } = location.state || {}; // Get user_id from location state
    const [profileData, setProfileData] = useState(null); // State for profile data
    const [loading, setLoading] = useState(true); // State for loading indicator
    const [imageSize, setImageSize] = useState({ width: 960, height: 0 });
    const bannerHeight = 263; // Height of the banner
    const gender = localStorage.getItem('gender');
    const defaultImage = gender === 'F' ? boyBanner : girlBanner;
    const profileImg = gender === 'M' ? boyImg : gitlImg;

    // Function to handle share button click
    const handleShareClick = () => {
        const profileId = user_id || id; // Get the profile ID from either user_id or id
        if (!profileId) {
            toast.error("Unable to generate share link");
            return;
        }

        const profileUrl = `${window.location.origin}/profile-view/${profileId}`;

        // Copy to clipboard
        navigator.clipboard.writeText(profileUrl)
            .then(() => {
                toast.success("Profile link copied to clipboard!");
            })
            .catch((err) => {
                console.error('Failed to copy: ', err);
                toast.error("Failed to copy link");
            });
    };

    useEffect(() => {
         window.scrollTo(0, 0);
        const fetchProfileData = async () => {
            if (user_id) {
                try {
                    const response = await getProfileById({ user_id }); // Call the API with user_id
                    setProfileData(response.data); // Set the profile data
                } catch (error) {
                    toast.error(error.response.data.message); // Show error toast
                } finally {
                    setLoading(false); // Stop loading
                }
            } else if (id) {
                try {
                    const response = await getProfileById({ user_id: id }); // Call the API with user_id
                    setProfileData(response.data); // Set the profile data
                } catch (error) {
                    toast.error(error.response.data.message); // Show error toast
                } finally {
                    setLoading(false); // Stop loading
                }
            } else {
                setLoading(false); // Stop loading if user_id is not available
            }
        };

        fetchProfileData(); // Fetch profile data if user_id exists
    }, [user_id]); // Dependency array ensures this runs when user_id changes

    if (loading) {
        return (
            <div className='col-lg-9 col-12 text-left'>
                {/* Skeleton Loader for CardHeader */}
                <Skeleton variant="rectangular" width="100%" height={50} />
                {/* Skeleton Loader for Profile Details */}
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <div style={{ display: 'flex', gap: '10px' }}>
                    <Skeleton variant="text" width="100px" height={30} />
                    <Skeleton variant="text" width="150px" height={30} />
                </div>
                {/* Skeleton Loader for Other Profile Details */}
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
                <Skeleton variant="text" width="100%" height={25} />
            </div>
        );
    }
    if (!profileData) return <p>No Profile Data Available.</p>; // Handle no data

    const imageUrl = profileData.search.user_info?.photo || defaultImage;

    // Function to get the image size
    const getImageSize = (url) => {
        const img = new Image();
        img.src = url;

        img.onload = () => {
            setImageSize({ width: img.width, height: img.height });
        };

        img.onerror = () => {
            console.error("Error loading image");
        };
    };

    // Call the function to get image size
    getImageSize(imageUrl);

    const isImageFit = imageSize.width > 0 && imageSize.height === bannerHeight;
    const userHobbies = profileData?.search?.hobbies?.original || [];
    const handleEdit = (path, data) => {
        navigate(path, { state: { userId: data } });
    }

    return (
        <div className="col-lg-9 col-12 text-left">
            <CardHeader
                avatar={
                    <ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />
                }
                action={
                    <IconButton aria-label="share" onClick={handleShareClick}>
                        <ShareIcon sx={{ color: '#FF8008' }} />
                    </IconButton>
                }
                title="Detail View"
                subheader=""
                titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }} />
            {/* <!-- Slider Start --> */}
            <div id="carouselExampleControlsNoTouching" className="carousel slide" data-bs-touch="false" data-bs-interval="false">
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <div className="editProfileBlock">
                            <div
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: `${bannerHeight}px`,
                                    display: 'flex',
                                    alignItems: 'center',
                                    overflow: 'hidden',
                                    border: '1px solid',
                                }}
                            >
                                {/* Left Blurred Section */}
                                {!isImageFit && (
                                    <div
                                        style={{
                                            flex: 1,
                                            height: '100%',
                                            backgroundImage: `url(${imageUrl})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            filter: 'blur(20px)',
                                        }}
                                    />
                                )}
                                {/* Center Image Section */}
                                <div
                                    style={{
                                        flex: 'none',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <img
                                        src={imageUrl}
                                        alt="profile"
                                        style={{
                                            height: '100%',
                                            objectFit: isImageFit ? 'cover' : 'contain',
                                        }}
                                    />
                                </div>

                                {/* Right Blurred Section */}
                                {!isImageFit && (
                                    <div
                                        style={{
                                            flex: 1,
                                            height: '100%',
                                            backgroundImage: `url(${imageUrl})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            filter: 'blur(20px)',
                                        }}
                                    />
                                )}
                            </div>
                            <div className="idBlockBG">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="userid">
                                        <h5><strong>ID - {profileData.search.user_info.username}, {profileData.search.user_info.age}</strong>

                                            <span className="greenOnline">
                                                {profileData.search.user_info.lastLogin === 'Online' ? (
                                                    <img src={greenOnline} alt="Status Icon" />
                                                ) : (
                                                    ''
                                                )} {profileData.search.user_info.lastLogin}</span>
                                        </h5>
                                    </div>
                                    <div>
                                        <div>
                                            <a className="btn photoBtn" href='javascript:void(0)' onClick={() => handleEdit('/view-user-photos', profileData?.search?.user_info?.register_id)}>
                                                <img src={photoImg} /> <span>{profileData.search.user_info.photoCount}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="profileDetailsBlock mainProfileBG">
                                <div className="profileTltGirl d-flex justify-content-between align-items-center">
                                    <h3>Profile Details</h3>
                                    {profileData.search.user_info.membership_type !== 'Free ' && (
                                        <h3 className="redTxtBG">{profileData.search.user_info.membership_type}</h3>
                                    )}
                                </div>

                                <div className="mt-3">
                                    <div className="personlDetails py-2">
                                        <div className="row">
                                            <div className="detailTlts">
                                                <h5>Basic Details</h5>
                                            </div>
                                            <div className="col-md-6">

                                                {profileData?.search?.user_info?.register_by_value && (
                                                    <p><img src={ProfileEditIcon} width="24" height="24" /> Profile managed by {profileData.search.user_info.register_by_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.name && (
                                                    <p><img src={Profileicon} width="24" height="24" /> Name - {profileData.search.user_info.name} {profileData?.search?.user_info?.last_name}</p>
                                                )}
                                                {profileData?.search?.user_info?.height && (
                                                    <p><img src={heightIcon} width="24" height="24" /> {profileData.search.user_info.height}</p>
                                                )}
                                                {profileData?.search?.user_info?.religion && (
                                                    <p><img src={Religion} width="24" height="24" /> {profileData.search.user_info.religion} - {profileData.search.user_info.caste}</p>
                                                )}
                                                {profileData?.search?.user_info?.mother_tongue_value && (
                                                    <p><img src={MotherTongue} width="24" height="24" /> Mother Tongue is {profileData.search.user_info.mother_tongue_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.bloodGroup && (
                                                    <p><img src={BloodGroupIcon} width="24" height="24" /> Blood Group - {profileData.search.user_info.bloodGroup}</p>
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                {profileData.search.user_info.city && profileData.search.user_info.state && profileData.search.user_info.country && (
                                                    <p><img src={locationIcon} width="24" height="24" /> {profileData.search.user_info.city}, {profileData.search.user_info.state}, {profileData.search.user_info.country}</p>
                                                )}
                                                {/* {profileData.search.user_info.income_value && (
                                                    <p><img src={salaryIcon} width="24" height="24" /> Rs. {profileData.search.user_info.income_value} P.A</p>
                                                )} */}
                                                {profileData.search.user_info.date_of_birth && (
                                                    <p>
                                                        <img src={BirthdayIcon} width="24" height="24" />
                                                        {
                                                            isNaN(Date.parse(profileData.search.user_info.date_of_birth))
                                                                ? profileData.search.user_info.date_of_birth
                                                                : new Date(profileData.search.user_info.date_of_birth).toLocaleDateString('en-GB', {
                                                                    day: 'numeric',
                                                                    month: 'long',
                                                                    year: 'numeric',
                                                                })
                                                        }
                                                    </p>
                                                )}

                                                {profileData.search.user_info.marital_status_value && (
                                                    <p><img src={MarritialStatusIcon} width="24" height="24" /> {profileData.search.user_info.marital_status_value}</p>
                                                )}
                                            </div>
                                            {profileData.search.user_info.about_me &&
                                                (
                                                    <div className="my-2 add_data">
                                                        <p className="aboutfil">About me</p>
                                                        <p>{profileData.search.user_info.about_me}</p>
                                                    </div>
                                                )}

                                            <div className="detailTlts">
                                                <h5>Education</h5>
                                                {profileData.search.user_info.education && (
                                                    <p> <img src={educIcon} width="24" height="24" /> {profileData.search.user_info.education}-  {profileData.search.user_info.educationDetail}</p>
                                                )}

                                            </div>
                                            <div className="detailTlts">
                                                <h5>Career</h5>
                                                {profileData.search.user_info.occupation && (
                                                    <p> <img src={jobIcon} width="24" height="24" /> {profileData.search.user_info.occupation} - {profileData.search.user_info.occupationDetail}</p>
                                                )}

                                                {profileData.search.user_info.income_value && (
                                                    <p><img src={salaryIcon} width="24" height="24" /> Salary - {profileData.search.user_info.income_value}  P.A</p>
                                                )}
                                                {profileData.search.user_info.residing_country && (
                                                    <p><img src={countryIcon} width="24" height="24" /> Residence Country - {profileData.search.user_info.residing_country}</p>
                                                )}
                                                {profileData.search.user_info.residing_state && (
                                                    <p><img src={stateIcon} width="24" height="24" /> Residence State - {profileData.search.user_info.residing_state}</p>
                                                )}
                                                {profileData.search.user_info.residing_city && (
                                                    <p><img src={cityIcon} width="24" height="24" /> Residence City - {profileData.search.user_info.residing_city}</p>
                                                )}
                                            </div>
                                            <div className="detailTlts">
                                                <h5>Family Details</h5>
                                                {profileData.search.user_info.fatherName && (
                                                    <p><img src={FatherNameIcon} width="24" height="24" /> Father's Name - {profileData.search.user_info.fatherName}</p>
                                                )}
                                                {profileData.search.user_info.fatherProfessions && (
                                                    <p><img src={FatherOccupationIcon} width="24" height="24" /> Father's Profession - {profileData.search.user_info.fatherProfessions}</p>
                                                )}
                                                {profileData.search.user_info.motherName && (
                                                    <p><img src={MotherNameIcon} width="24" height="24" /> Mother's Name - {profileData.search.user_info.motherName}</p>
                                                )}
                                                {profileData.search.user_info.motherProfession && (
                                                    <p><img src={MotherOccupationIcon} width="24" height="24" /> Mother's Profession - {profileData.search.user_info.motherProfession} </p>
                                                )}
                                                {/* {(profileData.search.user_info.unMarriedBrothers || profileData.search.user_info.marriedBrothers) && ( */}
                                                <p>
                                                    <img src={Siblingsicon} alt="family professions" width="24" height="24" />  Siblings -
                                                    {profileData.search.user_info && (
                                                        (profileData.search.user_info.unMarriedBrothers !== undefined || profileData.search.user_info.marriedBrothers !== undefined) &&
                                                        (profileData.search.user_info.unMarriedSister !== undefined || profileData.search.user_info.marriedSister !== undefined)
                                                    ) ? ' ' : ''}

                                                    {profileData.search.user_info && (
                                                        (profileData.search.user_info.unMarriedBrothers || profileData.search.user_info.marriedBrothers || 0) > 0
                                                    ) ? `${(profileData.search.user_info.unMarriedBrothers || 0) + (profileData.search.user_info.marriedBrothers || 0)} Brother's (${(profileData.search.user_info.marriedBrothers || 0) > 0 ? profileData.search.user_info.marriedBrothers : 0} married)` : ''}

                                                    {profileData.search.user_info && (
                                                        (profileData.search.user_info.unMarriedBrothers !== undefined || profileData.search.user_info.marriedBrothers !== undefined) &&
                                                        (profileData.search.user_info.unMarriedSister !== undefined || profileData.search.user_info.marriedSister !== undefined)
                                                    ) ? '  ' : ''}

                                                    {profileData.search.user_info && (
                                                        (profileData.search.user_info.unMarriedSister || profileData.search.user_info.marriedSister || 0) > 0
                                                    ) ? `${(profileData.search.user_info.unMarriedSister || 0) + (profileData.search.user_info.marriedSister || 0)} Sister's (${(profileData.search.user_info.marriedSister || 0) > 0 ? profileData.search.user_info.marriedSister : 0} married)` : ''}
                                                </p>
                                                {/* )} */}

                                                {profileData.search.user_info.family_values && (
                                                    <p> <img src={familyValueIcon} width="24" height="24" /> Family Value - {profileData?.search?.user_info?.family_values}</p>
                                                )}
                                                {profileData.search.user_info.family_types && (
                                                    <p> <img src={jointFamilyIcon} width="24" height="24" /> Family Type - {profileData?.search?.user_info?.family_types}</p>
                                                )}
                                                {profileData.search.user_info.family_status && (
                                                    <p> <img src={familyStatusIcon} width="24" height="24" /> Family Status - {profileData?.search?.user_info?.family_status}</p>
                                                )}
                                                {profileData.search.user_info.familyOrigin && (
                                                    <p> <img src={familyOriginIcon} width="24" height="24" /> Family Origin - {profileData?.search?.user_info?.familyOrigin}</p>
                                                )}
                                                {profileData.search.user_info.aboutFamily && (
                                                    <div className="my-2 add_data">
                                                        <p className="aboutfil">About Family</p>
                                                        <p>{profileData.search.user_info.aboutFamily}</p>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="detailTlts">
                                                <h5>Religion Kundli and Astro</h5>
                                                {profileData?.search?.user_info?.domain && (
                                                    <p><img src={domainIcon} width="24" height="24" /> Domain - {profileData?.search?.user_info?.domain}</p>
                                                )}
                                                {profileData?.search?.user_info?.religion && (
                                                    <p><img src={Religion} width="24" height="24" /> Religion - {profileData?.search?.user_info?.religion}</p>
                                                )}
                                                {profileData?.search?.user_info?.caste && (
                                                    <p><img src={Community} width="24" height="24" /> Community - {profileData?.search?.user_info?.caste}</p>
                                                )}

                                                {profileData?.search?.user_info?.subcaste && (
                                                    <p><img src={subCaste} width="24" height="24" /> Sub Community - {profileData?.search?.user_info?.subcaste}</p>
                                                )}
                                                {profileData?.search?.user_info?.gothram && (
                                                    <p><img src={gothraIcon} width="24" height="24" /> Gothram - {profileData?.search?.user_info?.gothram}</p>
                                                )}
                                                {profileData?.search?.user_info?.star_value && (
                                                    <p><img src={starIcon} width="24" height="24" /> Star - {profileData?.search?.user_info?.star_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.padam_value && (
                                                    <p><img src={padma} width="24" height="24" /> Padam - {profileData?.search?.user_info?.padam_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.sevvaiDosham && (
                                                    <p><img src={sevvaiDosham} width="24" height="24" /> Sevvai Dosham - {profileData?.search?.user_info?.sevvaiDosham}</p>
                                                )}
                                                {profileData?.search?.user_info?.mother_tongue_value && (
                                                    <p><img src={MotherTongue} width="24" height="24" /> Mother Tongue - {profileData?.search?.user_info?.mother_tongue_value}</p>
                                                )}
                                            </div>
                                            <div className="detailTlts">
                                                <h5>Lifestyle & Interests</h5>
                                                {profileData?.search.user_info?.height && (
                                                    <p><img src={heightIcon} width="24" height="24" /> Height - {profileData?.search.user_info?.height}</p>
                                                )}
                                                {profileData?.search?.user_info?.weight_value && (
                                                    <p><img src={weightIcon} width="24" height="24" /> Weight - {profileData?.search?.user_info?.weight_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.physical_status_value && (
                                                    <p><img src={normalIcon} width="24" height="24" /> Physical Status - {profileData?.search?.user_info?.physical_status_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.body_type_value && (
                                                    <p><img src={bodyIcon} width="24" height="24" /> Body Type - {profileData?.search?.user_info?.body_type_value}</p>
                                                )}
                                                {profileData?.search?.user_info?.complexion_value && (
                                                    <p><img src={fairIcon} width="24" height="24" /> Complexion - {profileData?.search?.user_info?.complexion_value}</p>
                                                )}
                                                <p><b>Habits</b></p>
                                                <div className="row d-flex">
                                                    {profileData?.search?.user_info?.drinking_value && (
                                                        <p className="habitsSec col-md-3"><img src={drinkIcon} width='24px' height='24px' /> Drinking Habits : {profileData.search.user_info.drinking_value} </p>
                                                    )}
                                                    {profileData?.search?.user_info?.eating_value && (
                                                        <p className="habitsSec col-md-3"><img src={dietIcon} width='24px' height='24px' /> Dietary Habits : {profileData.search.user_info.eating_value} </p>
                                                    )}
                                                    {profileData?.search?.user_info?.smoking_value && (
                                                        <p className="habitsSec col-md-3"><img src={smokingIcon} width='24px' height='24px' /> Smoking Habits : {profileData.search.user_info.smoking_value}</p>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="detailTlts">
                                                <h5>Hobbies</h5>
                                                {userHobbies.length > 0 ? (
                                                    userHobbies.map((hobbyType, index) => (
                                                        <div key={index} className="mt-2">
                                                            <p><b>My Favourites {hobbyType.hobbies_type.type
                                                                .replace(/^Favourite_/, '')
                                                                .replace(/^Favorite/, '')
                                                                .replace(/_/g, ' ')}</b></p>
                                                            <div className="hoibisSec">
                                                                {hobbyType.hobbies_type.hobbies.map((hobby, hobbyIndex) => (
                                                                    <p key={hobbyIndex}>{hobby}</p>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No hobbies found.</p>
                                                )}
                                            </div>
                                            {profileData.search.partner.aboutLifePartner && (
                                                <div className="my-2 add_data">
                                                    <p className="aboutfil">About Life Partner</p>
                                                    <p>{profileData.search.partner.aboutLifePartner}</p>
                                                </div>
                                            )}
                                            <Box sx={{ padding: '8px' }}>
                                                <Grid
                                                    container
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    spacing={3}
                                                    sx={{ flexWrap: 'nowrap', overflowX: 'auto' }}
                                                >
                                                    {/* Preference Section */}
                                                    <Grid item>
                                                        <Box textAlign="center">
                                                            <Typography variant="body1" fontWeight="bold">
                                                                Preference
                                                            </Typography>
                                                            <img src={profileData.search.user_info && profileData.search.user_info.photo ? profileData.search.user_info.photo : defaultImage} width="60px" height="60px" style={{ borderRadius: "50%" }} alt="" />
                                                        </Box>
                                                    </Grid>
                                                    {/* Match Count Section */}
                                                    <Grid item>
                                                        <Box textAlign="center">
                                                            <Typography variant="body2">
                                                                You match {profileData.search.total_matches} of her preference
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    {/* You Match Section */}
                                                    <Grid item>
                                                        <Box className="text-center">
                                                            <Typography variant="body2" fontWeight="bold">
                                                                You Match
                                                            </Typography>
                                                            <img src={profileData.search.owner_data && profileData.search.owner_data.photo ? profileData.search.owner_data.photo : profileImg} width="60px" height="60px" style={{ borderRadius: "50%" }} alt="" />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Box>

                                            {Object.entries(profileData.search.match_result).map(([section, detail]) => {
                                                // Check if detail has any non-empty values
                                                const hasData = Object.values(detail).some(details => details.value !== '');

                                                if (!hasData) return null; // If no data, don't render anything

                                                return (
                                                    <>
                                                        <div key={section} className="mt-3">
                                                            <p className="matchTxts">
                                                                Desired {`${section.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`}
                                                            </p>
                                                        </div>

                                                        {Object.entries(detail).map(([key, details]) => (
                                                            <div key={key} className="d-flex justify-content-between align-items-center detailsBG">
                                                                <div>
                                                                    <p className="yertoyer py-0">{`${key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}`}</p>
                                                                    <p className="mangTxt">
                                                                        {Array.isArray(details.value)
                                                                            ? `${details.value[0]} to ${details.value[1]}`
                                                                            : details.value}
                                                                    </p>
                                                                </div>
                                                                <div>
                                                                    <img
                                                                        src={details.match === 'Yes' ? greenCheckIcon : grayCheckIcon}
                                                                        alt="Match Icon"
                                                                    />
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                );
                                            })}

                                            <div className="d-flex justify-content-between align-items-center action-container">
                                                <ActionButton profileData={profileData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </div>
    )
}